// Topic keys MUST match the backend JobsHelpTopics map exactly (key sent to the
// API, label shown in the Select). See Core/BevNET.Core.Application/Jobs/Contact/JobsHelpTopics.cs
export interface IHelpTopic {
  key: string;
  label: string;
}

export const HELP_TOPICS: IHelpTopic[] = [
  { key: 'job_listing', label: 'Job listing question' },
  { key: 'sales', label: 'Sales & advertising' },
  { key: 'billing', label: 'Billing & payment' },
  { key: 'technical', label: 'Technical issue' },
  { key: 'other', label: 'Other' },
];
